import { useTranslation } from "react-i18next";
import { RenderNavItem } from "../components/RenderNavItem";
import { SWMLeftMenuList } from "../utils/constants";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";

const Solid_Waste_water_supply_faqs = () => {
  const { t, i18n, ready } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img
            src="assets/img/Banner/portal-banner6.jpg"
            className="img-fluid"
            alt="a"
          />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> {t("Water Supply :: FAQs")} </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {SWMLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      {t("Water Supply :: FAQs")}
                    </h3>
                  </div>
                </div>
              </div>
              <div id="accordion">
                <div className="card">
                  <div className="card-header" id="heading1">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse1"
                      aria-expanded="true"
                      aria-controls="collapse1"
                    >
                      {t("What are the key activities of the Department?")}
                    </button>
                  </div>
                  <div
                    id="collapse1"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "The objective of the water supply department Kolkata Municipal Corporation (KMC) is to provide uninterrupted water supply to the residents of Kolkata. The key activities undertaken by the department are:"
                        )}
                      </p>
                      <p className="fontSizeClass">
                        <strong> {t("a.Generation:")}</strong>
                        {t(
                          "The river Hoogly is the main source of water supply for Kolkata. After drawing water from the river, KMC treats the water at Indira Gandhi Water Treatment Plant (WTP) of capacity 260 million gallons per day at Palta Water Works. Water from this water works is sent to Tallah pumping station for temporary storage and onward distribution to the City."
                        )}
                      </p>
                      <p className="fontSizeClass">
                        <strong> {t("b.Distribution:")} </strong>
                        {t(
                          "Water supply department has divided the city into 7 zones based on hydraulic pattern and best engineering practices. The seven zones are : Central, North, South, West, Jadavpur Unit, SSU/GRU, and Tube Well (TW). Water is supplied through water pipe network to all over the City for ultimate utilisation by domestic as well as ICI Consumers."
                        )}
                      </p>
                      <p className="fontSizeClass">
                        <strong> {t("c.Other Works:")} </strong>
                        {t(
                          "Water Supply Department also supplies water for shipping, supply through tankers, regular use and emergency handling of maintenance works."
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading2">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse2"
                      aria-expanded="true"
                      aria-controls="collapse2"
                    >
                      {t(
                        "How can I get a water supply connection for my new house?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse2"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          " Different steps for getting water supply connection : a.Contact the Assistant Engineer of the local office of the Water Supply Department. b.Collect the list of plumbers from the local Section office or you may download the same from the KMC website. c. Select a plumber and the plumber will prepare the estimate. The user should apply in the prescribed format (Annex F) and place it before the Assistant Engineer for sanction. d. After sanction, deposit the amount and get connection. e. Fee includes Deposit Money, Water Charges, Connection Fees, Road Opening Fees, Road Restoration Fees etc."
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading3">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse3"
                      aria-expanded="true"
                      aria-controls="collapse3"
                    >
                      {t(
                        "Where can I procure the water supply application form? Do I have to pay for it?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse3"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "You can procure the application form available in net from the Headquarters or download it from the internet or take a xerox copy of the form from your plumber."
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading4">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse4"
                      aria-expanded="true"
                      aria-controls="collapse4"
                    >
                      {t(
                        "What documents are required for submission along with application form?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse4"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "You would be required to submit the following documents:- 1. Xerox copy of building sanction plan"
                        )}
                        <br />
                        {t(
                          " 2. Receipt of the payment of building sanction fees"
                        )}
                        <br />
                        {t(
                          "3. No Objection Certificate from the assessment and collection department "
                        )}
                        <br />
                        {t("4. Plumber “Niyog patra”")}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading5">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse5"
                      aria-expanded="true"
                      aria-controls="collapse5"
                    >
                      {t(
                        "Where should I deposit the application form and the required attachments?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse5"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "Kindly deposit the documents at your concerned Section office. The Section office would inspect your premises, prepare an estimate of expenses and hand over the application form duly signed by the Assistant Engineer to the citizen or his agent i.e. the plumber."
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading6">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse6"
                      aria-expanded="true"
                      aria-controls="collapse6"
                    >
                      {t("Where should I make the payment?")}
                    </button>
                  </div>
                  <div
                    id="collapse6"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "You can only make the payment for the water supply connection at eKolkata centre or the KMC Borough office or C.M.O. Building (5, S. N. Banerjee Road)"
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading7">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse7"
                      aria-expanded="true"
                      aria-controls="collapse7"
                    >
                      {t(
                        "What would be the components of the water supply connection charges for building construction purposes?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse7"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "You would be required to pay connection fees, restoration charges and road opening charges. The size of ferrule &amp; connection fees are calculated as per given in the following tables."
                        )}
                      </p>
                      <div className="mayor-table2 depart">
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-warning table-bor-2">
                              <th scope="col"> {t("Building")} </th>
                              <th scope="col"> {t("Ferrule Size")} </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td scope="row"> {t("Upto 2nd storied")} </td>
                              <td> 15 mm </td>
                            </tr>
                            <tr>
                              <td scope="row"> {t("Upto 3nd storied")} </td>
                              <td>20 mm</td>
                            </tr>
                            <tr>
                              <td scope="row">
                                {t("Upto 4th storied and above")}
                              </td>
                              <td>25 mm</td>
                            </tr>
                          </tbody>
                        </table>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-warning table-bor-2">
                              <th scope="col"> {t("Sl.No.")} </th>
                              <th scope="col"> {t("Building")} </th>
                              <th scope="col">
                                {t("Amount(Rs)(For each ferrule connection)")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td scope="row"> 1 </td>
                              <td>
                                {t("If Height of building &lt;= 8.5 meters")}
                              </td>
                              <td> 4000 </td>
                            </tr>
                            <tr>
                              <td scope="row">2</td>
                              <td>
                                {t(
                                  "If Height of building &gt; 8.5 meters and &lt;"
                                )}
                                {t("14.5 meters")}
                              </td>
                              <td> 10000 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 3 </td>
                              <td>
                                {t("If Height of building &gt; 14.5 meters")}
                              </td>
                              <td> 4000 </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading18">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse18"
                      aria-expanded="true"
                      aria-controls="collapse18"
                    >
                      {t(
                        "What are the expected timelines of performance of the following activities?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse18"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <div className="mayor-table2 depart">
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-warning table-bor-2">
                              <th className="bd-wid" scope="col">
                                Sl.No.
                              </th>
                              <th scope="col"> {t("Activity")} </th>
                              <th scope="col">
                                {t("Approximate response time")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td scope="row"> 1 </td>
                              <td>
                                {t(
                                  "Inspection of premises after application form is submitted at Section office"
                                )}
                              </td>
                              <td> {t("3 Days ")}</td>
                            </tr>
                            <tr>
                              <td scope="row"> 2 </td>
                              <td>
                                {t(
                                  "Issuance of demand notice after completion of inspection"
                                )}
                              </td>
                              <td> {t("3 Days")} </td>
                            </tr>
                            <tr>
                              <td scope="row"> 3 </td>
                              <td>
                                {t(
                                  "Sanction Certificate for water connection after receipt of payment"
                                )}
                              </td>
                              <td> {t("1 Days")} </td>
                            </tr>
                            <tr>
                              <td scope="row"> 4 </td>
                              <td>
                                {t(
                                  " Processing of application for reconnection of water supply"
                                )}
                              </td>
                              <td> {t("3 Days")} </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading19">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse19"
                      aria-expanded="true"
                      aria-controls="collapse19"
                    >
                      {t(
                        "What should I do in case of an excessive delay in the approval of water supply connection?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse19"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "In the unlikely event of delay in approval kindly contact the Deputy Chief engineer, Water Supply at the KMC, Headquarters. Ph.No. 22861100-08, Extn: 2573."
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading20">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse20"
                      aria-expanded="true"
                      aria-controls="collapse20"
                    >
                      {t(
                        "Whom should I contact for non-supply of water or to lodge complaints for supply of unhygienic water?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse20"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "For non-supply of water, kindly contact the Assistant Engineer of the concerned office at your locality. Please refer to the following table."
                        )}
                      </p>
                      <div className="mayor-table2 depart">
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-warning table-bor-2">
                              <th className="bd-wid" scope="col">
                                {"Sl.No."}
                              </th>
                              <th scope="col">
                                {t("Name of the Local Office")}
                              </th>
                              <th scope="col"> {t("Ward No.")} </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td scope="row"> 1 </td>
                              <td>
                                {t(
                                  "Cossipur Section, 10, B.T. Road, Kolkata-700002 Ph: 2558 8553"
                                )}
                              </td>
                              <td> 1, 2, 3, 4, 5, 6 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 1 </td>
                              <td>
                                {t(
                                  "Hatibagan Section, 79, Bidhan Sarani, Kolkata-700006 Ph: 2543 1602"
                                )}
                              </td>
                              <td> 7, 8, 9, 10, 11, 12, 15</td>
                            </tr>
                            <tr>
                              <td scope="row"> 3 </td>
                              <td>
                                {t(
                                  "Brindaban Bose Section, 28, Brindaban Bose Lane, Kolkata-700006, KMC Building"
                                )}
                              </td>
                              <td> 16, 17, 18, 19, 20 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 4 </td>
                              <td>
                                {t(
                                  " B. K. Pal Section,105, B. K. Pal Avenue, (Near the B.K. Pal Park), Kolkata-700005"
                                )}
                              </td>
                              <td> 21, 22, 23, 24, 25 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 5 </td>
                              <td>
                                {t(
                                  " Hedua Section, 6, Azad Hind Bagh, Hedua Square, Kolkata-700006"
                                )}
                              </td>
                              <td> 26, 27, 28, 38, 39 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 6 </td>
                              <td>
                                {t(
                                  "Section (Maniktala) 109, Narkeldanga Main Road,Kolkata-700011, Ph: 2364 9252"
                                )}
                              </td>
                              <td> 13, 14, 29, 30, 31, 32, 33, 34, 35 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 7 </td>
                              <td>
                                {t(
                                  "Section 'E' 1, Neel Madhab Sen Lane(Near Md. Ali Park), Kolkata-700073"
                                )}
                              </td>
                              <td> 41, 42, 43, 44, 45 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 8 </td>
                              <td>
                                {t(
                                  "Section 'F' 22, Surya Sen Street, Kolkata-700012, (Near Borough V office), Ph:2219 2399"
                                )}
                              </td>
                              <td> 36, 37, 40, 48, 49, 50 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 9 </td>
                              <td>
                                {t(
                                  "Section 'G', 23, Princep Street,Kolkata-700072"
                                )}
                              </td>
                              <td> 46, 47, 51 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 10 </td>
                              <td>
                                {t(
                                  "Section 'H' Hazi Md. Mohsin Square (Goltalab), Kolkata-700016"
                                )}
                              </td>
                              <td> 52, 53, 61, 62, 63 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 11 </td>
                              <td>
                                {t(
                                  "Section 'I', 13, Dilkhusha Street (Near Park Circus Tram Depot), Kolkata-700017"
                                )}
                              </td>
                              <td> 64, 65 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 12 </td>
                              <td>
                                {t(
                                  "  Section 'J', P-65, Dr. Sundari Mohan Avenue, Kolkata-700014 KMC Office"
                                )}
                              </td>
                              <td> 54, 55, 56, 57, 58, 59, 60 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 13 </td>
                              <td>
                                {t(
                                  "Picnic Garden, 105/2, Prasanna Naskar Lane(Near Colony Bazar), Kolkata-700039, Ph: 2334 3900"
                                )}
                              </td>
                              <td> 66, 67 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 14 </td>
                              <td>
                                {t(
                                  "Section 'K', 212, Rashbehari Avenue(Gariahat Market, 3rd Floor), Kolkata-700025"
                                )}
                              </td>
                              <td> 68, 69, 72, 84, 85, 86, 87, 90 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 15 </td>
                              <td>
                                {t(
                                  "Section 'L', 125,Hazra Road (At Hazra Road and Harish Mukherjee Road Crossing), ,Kolkata-700026 Ph: 2455 7978"
                                )}
                              </td>
                              <td> 70, 71, 73, 74, 82, 83, 88 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 16 </td>
                              <td>
                                {t(
                                  "Section 'M', 39,Circular Garden Reach Road (At Sudhir Bose Road and C.G.R.D. Road Junction), Kolkata-700024"
                                )}
                              </td>
                              <td> 75, 76, 77, 78, 79, 80 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 17 </td>
                              <td>
                                {t(
                                  "Section 'Tollygunge', Opposite Golf Green Daily Market, Uday Sankar Sarani, Kolkata-700045 Ph: 2483 6604"
                                )}
                              </td>
                              <td>
                                81, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100
                              </td>
                            </tr>
                            <tr>
                              <td scope="row"> 18 </td>
                              <td>
                                {t(
                                  "97 &amp; 98, Garfa Main Road, Borough - XII Office, Kolkata - 700 075"
                                )}
                              </td>
                              <td> 103, 104, 105, 106, 107, 108, 109 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 19 </td>
                              <td>
                                {t(
                                  "Baghajatin Market Complex, Unit-III, Baghajatin Station Road, Kolkata - 700 086"
                                )}
                              </td>
                              <td> 101, 102, 110, 111, 112, 113, 114 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 20 </td>
                              <td>
                                {t(
                                  "S.S. Unit, Behala, 516, D.H. Road, Borough-XIII and XIV Office, Kolkata - 700 034"
                                )}
                              </td>
                              <td>
                                115, 116, 117, 118, 119, 120, 121, 122, 123,
                                124, 125, 126, 127, 128, 129, 130, 131, 132
                              </td>
                            </tr>
                            <tr>
                              <td scope="row"> 21 </td>
                              <td>
                                {t(
                                  "G.R. Unit, E/3, Circular Garden Reach Road, Borough - XV Office, Kolkata - 700 024"
                                )}
                              </td>
                              <td>
                                133, 134, 135, 136, 137, 138, 139, 140, 141
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading21">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse21"
                      aria-expanded="true"
                      aria-controls="collapse21"
                    >
                      {t(
                        "How do we obtain permission for registration of existing and new power driver tubewells?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse21"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "All Account holders of the power driven tubewells within the KMC area are requested to collect the prescribed Form No.6 from the Tubewell Department, CMO Building, 2nd floor, 5, S N Banerjee Road, Kolkata 700013 for registration of their existing tubewell(s) under the provision of 'West Bengal Ground Water Resources (Management, Control and Regulation) Act, 2005' For new power driven tubewell(s), permission should be obtained from State Water Investigation Directorate (SWID) and necessary license taken from Kolkata Municipal Corporation by depositing the requisite license fees. Address of SWID - Bikash Bhavan, 5th Floor, Kolkata 700 019."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div id="accordion">
                <div className="card">
                  <div className="card-header" id="heading8">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse8"
                      aria-expanded="true"
                      aria-controls="collapse8"
                    >
                      {t(
                        "How should I apply for conversion of water connection for building construction into water connection for domestic use?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse8"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "Kindly submit application form along with a copy of the Occupancy Certificate at the Section office and pay the requisite fees at the head office based on the demand notice. In case you require the same ferrule size as was used in building construction for domestic use, then you need to pay a sum of Rs.1000 only for conversion and you are not required to take a new connection for domestic use. But, in case you require a different ferrule size you have to pay charges assuming you had requested for new connection"
                        )}
                        .
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading9">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse9"
                      aria-expanded="true"
                      aria-controls="collapse9"
                    >
                      {t(
                        "How would the fees be calculated for new connection in case of domestic use?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse9"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "Based on the ferrule size you would be required to pay connection fees. You would also be required to pay road restoration charges and road opening charges. Kindly refer to the following table."
                        )}
                      </p>
                      <div className="mayor-table2 depart">
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-warning table-bor-2">
                              <th scope="col"> {t("Ferrule Size")} </th>
                              <th scope="col">
                                {t(
                                  "Connection fee for domestic or other than I.C.I. connections (Rs.)"
                                )}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td scope="row"> 10 mm </td>
                              <td>
                                {t(
                                  "1500 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td scope="row"> 15 mm </td>
                              <td>
                                {t(
                                  "2000 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td scope="row"> 20 mm </td>
                              <td>
                                {t(
                                  "4500 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td scope="row"> 25 mm </td>
                              <td>
                                {t(
                                  "6000 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading10">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse10"
                      aria-expanded="true"
                      aria-controls="collapse10"
                    >
                      {t(
                        "How would the fees be calculated for new connection for commercial, Industrial or Institutional use?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse10"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "Based on the ferrule size you would be required to pay connection fees. You would also be required to pay road restoration charges and road opening charges. Kindly refer to the following table."
                        )}
                      </p>
                      <div className="mayor-table2 depart">
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-warning table-bor-2">
                              <th scope="col"> {t("Ferrule Size")} </th>
                              <th scope="col">
                                {t(
                                  "Connection fee for I.C.I. connections (Rs.)"
                                )}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td scope="row"> 10 mm </td>
                              <td>
                                {t(
                                  "5000 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td scope="row"> 15 mm </td>
                              <td>
                                {t(
                                  "7000 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td scope="row"> 20 mm </td>
                              <td>
                                {t(
                                  "8500 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td scope="row"> 25 mm </td>
                              <td>
                                {t(
                                  "10000 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading11">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse11"
                      aria-expanded="true"
                      aria-controls="collapse11"
                    >
                      {t(
                        "How would the fees be calculated for new connection for commercial, Industrial or Institutional use?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse11"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "Based on the ferrule size you would be required to pay connection fees. You would also be required to pay road restoration charges and road opening charges. Kindly refer to the following table."
                        )}
                      </p>
                      <div className="mayor-table2 depart">
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-warning table-bor-2">
                              <th scope="col"> {t("Ferrule Size ")}</th>
                              <th scope="col">
                                {t(
                                  "Connection fee for I.C.I. connections (Rs.)"
                                )}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td scope="row"> 10 mm </td>
                              <td>
                                {t(
                                  "5000 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td scope="row"> 15 mm </td>
                              <td>
                                {t(
                                  "7000 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td scope="row"> 20 mm </td>
                              <td>
                                {t(
                                  "8500 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td scope="row"> 25 mm </td>
                              <td>
                                {t(
                                  "10000 + Road restoration charges + Road opening charges"
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading12">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse12"
                      aria-expanded="true"
                      aria-controls="collapse12"
                    >
                      {t(
                        "What would be the monthly charges for commercial water supply at different Ferrule sizes?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse12"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "Based on the ferrule size you would be required to pay monthly charges in case you have an I.C.I. connection. Please refer to the following table."
                        )}
                      </p>
                      <div className="mayor-table2 depart">
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-warning table-bor-2">
                              <th scope="col"> {t("Ferrule Size")} </th>
                              <th scope="col">
                                {t(
                                  "Monthly Rate for Business / Non-Domestic Premises (Rs.)"
                                )}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td scope="row"> 10.00 mm </td>
                              <td> 525 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 15.00 mm </td>
                              <td> 1200 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 20.00 mm </td>
                              <td> 2000 </td>
                            </tr>
                            <tr>
                              <td scope="row"> 25.00 mm </td>
                              <td> 3000 </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading13">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse13"
                      aria-expanded="true"
                      aria-controls="collapse13"
                    >
                      {t(
                        "What would be charges for consumption of water through bulk meter be calculated?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse13"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "a) The current fee structure for water consumption through Bulk Meter is: For domestic purpose: Rs. 7/- per kilo-litre"
                        )}
                        <br />
                        {t(
                          "b) For Industrial, Commercial and Institutional purpose: Rs. 15/- per kilo-litre"
                        )}
                        <br />
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading14">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse14"
                      aria-expanded="true"
                      aria-controls="collapse14"
                    >
                      {t(
                        "How can I apply for reconnection of water supply or change of pipe or change of ferrule size?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse14"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "Kindly apply at the concerned Section office and pay the requisite fees"
                        )}
                        .
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading15">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse15"
                      aria-expanded="true"
                      aria-controls="collapse15"
                    >
                      {t(
                        "Whom should I contact for a water tanker and how much would it cost me?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse15"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "In order to get a water tanker in case of temporary shortage of water supply or on special occasions, kindly contact: Assistant Engineer (Mains), at H.P.L., 6, Convent Road, Ph: 2265-5785, 2265-5845. You would be required to pay Rs. 450 for each tanker of 3600 L capacity. This service is available between 7 a.m. to 6 p.m."
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading16">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse16"
                      aria-expanded="true"
                      aria-controls="collapse16"
                    >
                      {t(
                        "Whom should I contact for installation of new tube-wells or repair of damaged tube-wells?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse16"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "Kindly contact the Executive Engineer, Tubewell, 5, S.N. Banerjee Road, Kolkata – 700 013, Phone: 2286-1100-08, Extension 2567."
                        )}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading17">
                    <button
                      class="btn btn-link fontSizeClass "
                      data-toggle="collapse"
                      data-target="#collapse17"
                      aria-expanded="true"
                      aria-controls="collapse17"
                    >
                      {t(
                        "What are my duties as a citizen with respect to water supply? What may happen if I fail to perform my duties?"
                      )}
                    </button>
                  </div>
                  <div
                    id="collapse17"
                    className="collapse"
                    data-parent="#accordion"
                  >
                    <div className="card-body m-3">
                      <p className="fontSizeClass">
                        {t(
                          "The following are the duties of citizen w.r.t water a. All the parts of the pipelines within each premises should be protected and taken proper care of, to prevent the flow of dirty underground water. If required, you may have to install a new pipeline in place of your old existing damaged one at your own cost with the permission of the Corporation. b. Lids of underground and overhead reservoirs should be properly covered and the water flow should be properly maintained so that there is no damage. At least once in a week water should be emptied and bleached to prevent them from becoming the breeding place of germs and mosquitoes. If you fail to perform your duties in either of cases then, KMC may decide to disconnect your water supply."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Solid_Waste_water_supply_faqs;
